import ClaimReviewOverviewPageActionTypes from '../actions/claim-review-overview-page-action-types';

const initialState = {
  loading: false,
  claim: null,
  pdfObjectUrl: null,
  isRejectDialogVisible: false,
  rejectValidationResult: null,
  cancelToken: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ClaimReviewOverviewPageActionTypes.LOAD_CLAIM_REVIEW_OVERVIEW_START:
      return {
        ...state,
        loading: true
      };
    case ClaimReviewOverviewPageActionTypes.LOAD_CLAIM_REVIEW_OVERVIEW_END:
      return {
        ...state,
        loading: false,
        claim: action.payload?.claim ?? state.claim,
        pdfObjectUrl: action.payload?.pdfObjectUrl ?? state.pdfObjectUrl,
        rejectValidationResult: action.payload?.rejectValidationResult ?? null
      };
    case ClaimReviewOverviewPageActionTypes.TOGGLE_REJECT_DIALOG:
      return {
        ...state,
        isRejectDialogVisible: action.payload?.visible ?? false,
        rejectValidationResult: null
      };
    case ClaimReviewOverviewPageActionTypes.CLEANUP_CLAIM_REVIEW_OVERVIEW:
      return {
        ...initialState
      };
    default:
      return state;
  }
};
